module.exports = __webpack_public_path__ + "static/media/03.e65b8d07.jpg";